// extracted by mini-css-extract-plugin
export default {"ag-styles":"J_M","alert":"J_dj","info":"J_dk","flag":"J_dl"};